import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class BeforePlayerContractTerminatedEvent extends AbstractEvent {
  constructor(
    public player: Player,
  ) {
    super();
  }
}